module.exports = __webpack_public_path__ + "static/img/2-7.68fb0a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-2/2-7.jpg
// module id = 734
// module chunks = 1